import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const IMAGES = [
  { src: "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/vh256an6_IMG_0095.webp", caption: { en: "Sunset · Muse Rosé", gr: "Ηλιοβασίλεμα · Muse Rosé" }, span: "" },
  { src: "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/cdcnqmjz_IMG_0096.webp", caption: { en: "Bougainvillea by the sea", gr: "Βουκαμβίλια δίπλα στη θάλασσα" }, span: "" },
  { src: "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/h64vu7yr_IMG_0104.webp", caption: { en: "Banana leaves · a lounger", gr: "Φύλλα μπανάνας · μια ξαπλώστρα" }, span: "" },
  { src: "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/gbqrt4xc_IMG_0098.webp", caption: { en: "Light · after sundown", gr: "Φως · μετά τη δύση" }, span: "" },
  { src: "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/bpqsxqp4_IMG_0097.webp", caption: { en: "The garden path", gr: "Το μονοπάτι του κήπου" }, span: "" },
  { src: "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/3gl768ce_IMG_0099.webp", caption: { en: "Sand life · every corner", gr: "Sand life · σε κάθε γωνιά" }, span: "" },
];

export const Gallery = () => {
  const { t, L } = useLang();
  return (
    <section className="gallery" id="gallery" data-testid="gallery-section">
      <motion.div
        className="gallery__head"
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="label">{t.gallery.label}</p>
        <h2 className="display">
          {t.gallery.titleA} <em>{t.gallery.titleB}</em>
        </h2>
      </motion.div>

      <div className="gallery__grid">
        {IMAGES.map((img, i) => (
          <motion.figure
            key={img.src}
            className={`gallery__item ${img.span ? `gallery__item--${img.span}` : ""}`}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-30px" }}
            transition={{ duration: 0.8, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
          >
            <img src={img.src} alt={L(img.caption)} loading="lazy" />
            <figcaption>{L(img.caption)}</figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
